import { Button, Col, Icon, Input, message, Modal, Row, Table, Upload } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { gql } from 'apollo-boost';
import React, { MouseEvent, useState } from 'react';
import { Mutation } from 'react-apollo';
import { config } from 'src/config';
import { fileManager } from 'src/services/file';

import { client } from '../../services/api';
import { userQuery } from '../user/TransferOwnerOfCourse';
import { User } from '../user/Users';

interface FileParam {
  filename: string;
  originalFilename: string;
  fileSize: number;
  mimeType: string;
}

const MUTATION_CREATE_TEACHER = gql`
  mutation createTeacher(
    $avatar: FileParam!
    $wechatQrCode: FileParam!
    $nickname: String!
    $wechatContact: String!
    $userId: Int!
    $mobile: String!
  ) {
    createTeacher(
      avatar: $avatar
      wechatQrCode: $wechatQrCode
      nickname: $nickname
      wechatContact: $wechatContact
      userId: $userId
      mobile: $mobile
    ) {
      id
    }
  }
`;

interface Props {
  isVisible: boolean;
  hide: Function;
  onCancel: (e: MouseEvent<HTMLElement>) => void;
  onSuccess: () => Promise<void>;
}

export const CreateTeacher = (props: Props) => {
  const [isAvatarUploading, setIsAvatarUploading] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState();

  const [avatar, setAvatar] = useState<FileParam | undefined>();
  const [wechatQrCode, setWechatQrCode] = useState<FileParam | undefined>();

  const [isWechatQrCodeUploading, setIsWechatQrCodeUploading] = useState(false);
  const [wechatQrCodeUrl, setWechatQrCodeUrl] = useState();

  const [userList, setUserList] = useState<User[]>([]);
  const [nickname, setNickname] = useState();
  const [wechatContact, setWechatContact] = useState();
  const [mobile, setMobile] = useState<string | undefined>();
  const [name, setName] = useState<string | undefined>();
  const [userId, setUserId] = useState();

  const uploadImage = async (file: RcFile, onUploadEnded: Function) => {
    const isValidType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
    if (!isValidType) {
      message.error('图片格式必须为jpg,jpeg,png');
    }

    // file max size limit is 200kb
    const isOversized = file.size / 1024 / 1024 < 0.2;
    if (!isOversized) {
      message.error('图片必须小于200kb!');
      return false;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = async () => {
      try {
        const { fileNameWithExt } = (await fileManager.uploadToOss(file)) as {
          name: string;
          url: string;
          fileNameWithExt: string;
        };

        onUploadEnded(file, fileNameWithExt);
      } catch (e) {
        message.error('图片上传失败');
        console.log(e);
      }
    };

    return false; // 不调用默认的上传方法
  };

  const onClickSearchUser = async () => {
    if (!name || !name.trim()) {
      message.warning('请填写老师真实姓名～');
      return;
    }
    const response = await client.query<{
      users: User[];
    }>({
      query: userQuery,
      variables: { name },
    });
    const userList = (response.data && response.data.users) || [];
    if (!userList.length) {
      message.error('找不到相关用户！');
    }
    setUserList(userList);
  };

  const uploadButton = (text: string) => {
    return (
      <div>
        <Icon type={isAvatarUploading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">{text}</div>
      </div>
    );
  };

  return (
    <Mutation
      mutation={MUTATION_CREATE_TEACHER}
      variables={{
        nickname,
        wechatContact,
        avatar,
        wechatQrCode,
        userId,
        mobile,
      }}
    >
      {(createTeacher, { loading }) => {
        return (
          <Modal
            title="创建老师"
            visible={props.isVisible}
            onCancel={props.onCancel}
            onOk={async () => {
              if (loading || isAvatarUploading || isWechatQrCodeUploading) {
                return;
              }
              if (!nickname) {
                message.error('老师昵称不能为空');
                return;
              }
              if (!wechatContact) {
                message.error('老师微信号不能为空');
                return;
              }

              if (!mobile) {
                message.error('老师手机号不能为空');
                return;
              }

              if (!userId) {
                message.error('请选择具体用户');
                return;
              }

              if (!avatar) {
                message.error('老师头像不能为空');
                return;
              }
              if (!wechatQrCode) {
                message.error('老师二维码不能为空');
                return;
              }

              try {
                await createTeacher();
                props.hide();
                message.success('发送成功！');
                await props.onSuccess();
              } catch (error) {
                message.error(error.message);
              }
            }}
          >
            <Row style={{ marginTop: 8 }}>
              <Col span={24} style={{ textAlign: 'right' }}>
                <Input
                  placeholder="老师昵称"
                  value={nickname}
                  onChange={e => setNickname(e.target.value)}
                  disabled={loading}
                />
              </Col>
              <Col span={24} style={{ textAlign: 'right', marginTop: 10 }}>
                <Input
                  placeholder="老师微信用户名"
                  value={wechatContact}
                  onChange={e => setWechatContact(e.target.value)}
                  disabled={loading}
                />
              </Col>
              <Col span={24} style={{ textAlign: 'right', marginTop: 10 }}>
                <Input
                  placeholder="老师手机号"
                  value={mobile}
                  onChange={e => setMobile(e.target.value)}
                  disabled={loading}
                />
              </Col>
              <Col span={24} style={{ textAlign: 'right', marginTop: 10 }}>
                <Col span={16} style={{ textAlign: 'right', marginRight: 10 }}>
                  <Input
                    placeholder="老师真实姓名"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    disabled={loading}
                  />
                </Col>
                <Col span={4} style={{ textAlign: 'right' }}>
                  <Button onClick={onClickSearchUser} type="primary">
                    搜索
                  </Button>
                </Col>
              </Col>

              {!!userList.length && (
                <Col span={24} style={{ textAlign: 'right' }}>
                  <Table
                    rowKey="id"
                    rowSelection={{
                      type: 'radio',
                      onChange: (selectedRowKeys, selectedRows) => {
                        const [user] = selectedRows;
                        if (user.region !== '哆啦教育') {
                          message.error('请选择企业微信用户');
                          return;
                        }
                        setUserId(user.id);
                      },
                    }}
                    dataSource={userList}
                  >
                    <Table.Column key="id" dataIndex="id" title="id" />
                    <Table.Column key="mobile" dataIndex="mobile" title="手机号" />
                    <Table.Column key="name" dataIndex="name" title="昵称" />
                  </Table>
                </Col>
              )}

              <Col span={24} style={{ textAlign: 'right', marginTop: 10 }}>
                <Col span={6}>
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    showUploadList={false}
                    customRequest={async (e: any) => {
                      setIsAvatarUploading(true);
                      await uploadImage(e.file, (file: RcFile, fileNameWithExt: string) => {
                        setAvatar({
                          filename: fileNameWithExt,
                          mimeType: file.type,
                          originalFilename: file.name,
                          fileSize: file.size,
                        });
                        setAvatarUrl(`${config.ALIYUN_OSS_PREFIX_DOMAIN}/${fileManager.uploadPath(fileNameWithExt)}`);
                      });
                      setIsAvatarUploading(false);
                    }}
                    disabled={loading && isAvatarUploading}
                  >
                    {avatarUrl ? (
                      <img src={avatarUrl} alt="avatar" style={{ width: '100%' }} />
                    ) : (
                      uploadButton('老师头像')
                    )}
                  </Upload>
                </Col>
                <Col span={6}>
                  <Upload
                    name="wechatQrCode"
                    listType="picture-card"
                    showUploadList={false}
                    customRequest={async (e: any) => {
                      setIsWechatQrCodeUploading(true);
                      await uploadImage(e.file, (file: RcFile, fileNameWithExt: string) => {
                        setWechatQrCode({
                          filename: fileNameWithExt,
                          mimeType: file.type,
                          originalFilename: file.name,
                          fileSize: file.size,
                        });
                        setWechatQrCodeUrl(
                          `${config.ALIYUN_OSS_PREFIX_DOMAIN}/${fileManager.uploadPath(fileNameWithExt)}`,
                        );
                      });
                      setIsWechatQrCodeUploading(false);
                    }}
                    disabled={loading && isWechatQrCodeUploading}
                  >
                    {wechatQrCodeUrl ? (
                      <img src={wechatQrCodeUrl} alt="wechatQrCodeUrl" style={{ width: '100%' }} />
                    ) : (
                      uploadButton('老师微信二维码')
                    )}
                  </Upload>
                </Col>
              </Col>
            </Row>
          </Modal>
        );
      }}
    </Mutation>
  );
};



// WEBPACK FOOTER //
// ./src/screens/teacher/CreateTeacher.tsx